import React, { PropTypes } from 'react';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { Dropdown } from '@bibliocommons/base-dropdown';
import { Cog } from '@bibliocommons/base-icons';
import { FormattedMessage } from 'react-intl';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import './GroupingSummary.scss';

export default class GroupingSummary extends BcReactComponent {
  static renderOption(value, key) {
    return (
      <li key={key} className="menu-item" style={{ color: value ? 'green' : 'lightgrey' }}>
        <strong>{key}</strong>: {value}
      </li>
    );
  }

  static renderDefaultSelected() {
    return (
      <span>
        <Cog />
        <ScreenReaderMessage>
          <FormattedMessage id="debug_grouping_summary" />
        </ScreenReaderMessage>
      </span>
    );
  }

  render() {
    const { groupSummary } = this.props;
    return (
      <div className="cp-grouping-summary">
        <Dropdown
          selected={GroupingSummary.renderDefaultSelected()}
          handleSelect={() => {}}
          className="btn-link"
          right>
          {groupSummary && groupSummary.map(GroupingSummary.renderOption).toArray()}
        </Dropdown>
      </div>
    );
  }
}

GroupingSummary.propTypes = {
  groupSummary: PropTypes.objectOf(PropTypes.string)
};



// WEBPACK FOOTER //
// ./app/components/search/GroupingSummary/GroupingSummary.jsx